import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminProductsNew from './AdminProductsNew';

export default withRequiredAdmin(AdminProductsNew);
